import React, { useEffect, useState } from "react";
import back from "../../../assets/icons/back.svg";
import { useDispatch } from "react-redux";
import { productDetail } from "../../../redux/actions/productActions";
import { useParams } from "react-router-dom";
import ProductDivisionBasicView from "./ProductDivisionBasicView";
import ProductDivisionOffersView from "../../../components/division/product/ProductDivisionOffersView";
import LoadingSpinnerTable from "../../../components/utilites/loader";

const ProductDivisionView = ({ setActiveProduct, selectedProductId }) => {
  const dispatch = useDispatch();
  const params = useParams();
  const [productData, setProductData] = useState("");
  const [offerType, setOfferType] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    dispatch(
      productDetail(selectedProductId, onProductViewSuccess, onProductViewError)
    );
  }, []);

  const onProductViewSuccess = (data) => {
    setLoading(false);
    setProductData(data.data.data);
    setOfferType(data.data.data.vendorDivision.offer_type)
    console.log(data);
  };
  const onProductViewError = (err) => {
    setLoading(false);
    console.log(err);
  };

  return (
    <>
      <div
        className="main-list-container my-2 py-1 d-flex justify-content-between flex-column"
        style={{ position: "relative" }}
      >
        <main className="d-flex flex-column w-100 main-container">
          <div
            className="d-flex align-items-center p-2 ms-3 m-1 mb-2 cursor_pointer"
            onClick={() => setActiveProduct(11)}
          >
            <img src={back} alt="back_btn" />
            <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
              BACK
            </span>
          </div>
          {loading == true ? (
            <LoadingSpinnerTable />
          ) : (
            <>
              <ProductDivisionBasicView productData={productData} />
              <ProductDivisionOffersView
                offerType={offerType}
                offersList={productData?.productStateOffers}
                holding_value_unit={
                  productData?.productPackingDetail?.holding_value_unit
                }
              />
            </>
          )}
        </main>
      </div>
    </>
  );
};

export default ProductDivisionView;
